import Immutable, { Record, List } from 'immutable';

import AbilityDescription from './AbilityDescriptions';

const SubSkillRecord = Record({
  subSkillId: undefined,
  name: undefined,
  abilityDescriptions: new List(),
});

class SubSkill extends SubSkillRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'subSkillId':
      return [key, `${val}`];
    case 'abilityDescriptions':
      return [key, new List(val.map(AbilityDescription.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

SubSkill.create = (data) =>
  new SubSkill(data).mapEntries(reviver);

export default SubSkill;



// WEBPACK FOOTER //
// ./data/ProgressTests/Skills/SubSkills/model.js